import { OrganizationTreeNode } from 'src/models/organization';

const isRecord = (value: unknown): value is Record<string, unknown> => value !== null && typeof value === 'object';

const isOrganizationTreeNodeShape = (value: unknown): value is Record<string, unknown> => {
	if (!isRecord(value)) {
		return false;
	}

	return typeof value.id === 'string' && typeof value.name === 'string' && typeof value.type === 'string';
};

const normalizeTreeCollection = (value: unknown): OrganizationTreeNode[] => {
	if (Array.isArray(value)) {
		return value
			.map((entry) => normalizeTreeNode(entry))
			.filter((entry): entry is OrganizationTreeNode => entry !== null);
	}

	if (!isRecord(value)) {
		return [];
	}

	return Object.values(value)
		.map((entry) => normalizeTreeNode(entry))
		.filter((entry): entry is OrganizationTreeNode => entry !== null);
};

const normalizeTreeNode = (value: unknown): OrganizationTreeNode | null => {
	if (!isOrganizationTreeNodeShape(value)) {
		return null;
	}

	const children = normalizeTreeCollection(value.children);

	return {
		...value,
		children,
	} as OrganizationTreeNode;
};

const unwrapRootTreeNode = (nodes: OrganizationTreeNode[], rootNodeId: string): OrganizationTreeNode[] => {
	if (nodes.length !== 1 || nodes[0].id !== rootNodeId) {
		return nodes;
	}

	return normalizeTreeCollection(nodes[0].children);
};

export const normalizeOrganizationTreeResponse = (value: unknown, rootNodeId: string): OrganizationTreeNode[] => {
	if (isRecord(value) && !isOrganizationTreeNodeShape(value) && 'children' in value) {
		return normalizeTreeCollection(value.children);
	}

	return unwrapRootTreeNode(normalizeTreeCollection(value), rootNodeId);
};
